import { o as u } from "./query-assigned-elements-B8U94KLQ.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function d(t, l) {
  return u({ descriptor: (n) => {
    const i = { get() {
      var o, e;
      return (e = (o = this.renderRoot) === null || o === void 0 ? void 0 : o.querySelector(t)) !== null && e !== void 0 ? e : null;
    }, enumerable: !0, configurable: !0 };
    if (l) {
      const o = typeof n == "symbol" ? Symbol() : "__" + n;
      i.get = function() {
        var e, r;
        return this[o] === void 0 && (this[o] = (r = (e = this.renderRoot) === null || e === void 0 ? void 0 : e.querySelector(t)) !== null && r !== void 0 ? r : null), this[o];
      };
    }
    return i;
  } });
}
export {
  d as i
};
//# sourceMappingURL=query-D8_rwLua.js.map
